import { BaseService } from '../base/BaseService';
export class ProjectScheduleService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectScheduleService.DEFAULT_SERVICE_PATH,
            basePath: ProjectScheduleService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET /api/projects/{projectId}/schedule/critical-path?projectStart=ISO */
    async getCriticalPath(projectId, projectStart) {
        const response = await this.getCriticalPathRaw(projectId, projectStart);
        return response.data ?? null;
    }
    getCriticalPathRaw(projectId, projectStart) {
        const base = this.buildUrl(`${projectId}/schedule/critical-path`);
        const url = projectStart ? `${base}?projectStart=${encodeURIComponent(projectStart)}` : base;
        return this.http.get(url);
    }
    /** POST /api/projects/{projectId}/schedule/critical-path/preview (pure what-if) */
    async previewCriticalPath(projectId, request) {
        const response = await this.previewCriticalPathRaw(projectId, request);
        return response.data ?? null;
    }
    previewCriticalPathRaw(projectId, request) {
        return this.http.post(this.buildUrl(`${projectId}/schedule/critical-path/preview`), request);
    }
}
ProjectScheduleService.DEFAULT_SERVICE_PATH = 'projects';
ProjectScheduleService.BASE_PATH = 'api/projects';
//# sourceMappingURL=ProjectScheduleService.js.map